<template>
  <svg width="8" height="8" viewBox="0 0 8 8" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity=".843">
      <circle :stroke="color" stroke-width=".559" cx="3.913" cy="3.913" r="3.634" />
      <path
        d="M3.534 4.526c.044.132.132.22.263.22.132 0 .22-.088.263-.22l.175-2.41a.439.439 0 0 0-.438-.437c-.263 0-.438.219-.438.482l.175 2.365Zm.263.657c-.263 0-.438.176-.438.439 0 .262.175.438.438.438s.438-.176.438-.438c0-.263-.175-.439-.438-.439Z"
        :fill="color"
        fill-rule="nonzero"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Icon extends Vue {
  @Prop({ type: String, default: '#FFFFFF' }) color!: String;
}
</script>
